import React, { useEffect } from 'react'
import { TableProgramTerdaftarComp } from '../../components'
import { useLocation } from 'react-router-dom';

const ProgramTerdaftarPage = () => {
    
    const location = useLocation();

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);

    return (
        <>
            <h3>Program Terdaftar</h3>
            <div className='d-flex justify-content-between'>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#" style={{
                            color: '#B5B5C3'
                        }}>Beranda</a></li>
                        <li class="breadcrumb-item active" aria- current="page" style={{
                            color: '#3F4254'
                        }}>Program Terdaftar</li>
                    </ol>
                </nav>
            </div>

            <div className='row mt-4 mb-4'>
                <div className='col-lg-12'>
                    <TableProgramTerdaftarComp />
                </div>
            </div>
        </>
    )
}

export default ProgramTerdaftarPage
